<h1 mat-dialog-title><span i18n>Harmonogram akademického roka</span> {{zapisnyList.akademickyRok}}</h1>
<hr/>
<mat-card class="shadow-none">
    <mat-card-content class="d-flex justify-content-between">
        <div class="flex-grow-1">
            <ul class="p-2 m-2">
                <li class="mb-2" *ngFor="let u of data">{{u.text}}
                    <ul *ngIf="u.popis">
                        <li>{{u.popis}}</li>
                    </ul>
                </li>
            </ul>
        </div>
    </mat-card-content>
</mat-card>
<hr>
<div mat-dialog-actions class="flex-row-reverse">
    <button mat-stroked-button mat-dialog-close><span i18n>Close</span></button>
</div>




